import { render, staticRenderFns } from "./ArchivedStockMovementTable.vue?vue&type=template&id=2f71366f&scoped=true&"
import script from "./ArchivedStockMovementTable.vue?vue&type=script&lang=ts&"
export * from "./ArchivedStockMovementTable.vue?vue&type=script&lang=ts&"
import style0 from "./ArchivedStockMovementTable.vue?vue&type=style&index=0&id=2f71366f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f71366f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VCard,VDataTable,VDivider,VTextField})
